import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const IdTagIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M6.44455 6.44455H6.45566M6.44455 2H12.0002C12.5691 2 13.138 2.21667 13.5714 2.65113L21.3494 10.4291C21.766 10.8458 22 11.411 22 12.0002C22 12.5895 21.766 13.1546 21.3494 13.5714L13.5714 21.3493C13.1546 21.766 12.5895 22 12.0002 22C11.411 22 10.8458 21.766 10.4291 21.3493L2.65113 13.5714C2.44446 13.3653 2.28055 13.1204 2.16881 12.8508C2.05707 12.5811 1.9997 12.2921 2 12.0002V6.44455C2 5.26578 2.46826 4.13529 3.30178 3.30178C4.13529 2.46826 5.26578 2 6.44455 2Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

IdTagIcon.displayName = 'IdTagIcon';
